import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import bgIcon from "../../assets/images/home-bg.png";
import closeSvg from "../../assets/svg/delete.svg";
import { Input, Select, Button, Spin } from "antd";
import { Tour } from "antd-v5";
import {
  PlusOutlined,
  CloseCircleOutlined,
  SearchOutlined,
  MessageFilled,
  SendOutlined
} from "@ant-design/icons";
import compose from "recompose/compose";
import { connect } from "react-redux";
import {
  getQuickList,
  addQuick,
  removeQuick,
  searchOptions,
  searchAll
} from "../../actions/index";
import {
  editUserInfo,
  getUserInfo,
  getInnovateList,
  getReviewSummaryList,
  getStandardSubstanceList,
  getMedicalEquipmentList
} from "../../actions/subscribe";
import {
  getPublishList,
  getHumanList,
  getCmaList,
  getClassifyData,
  getTrainList,
  getReviewExportList,
  getAccessProblemList,
  getPracticalLinkList,
  getPunishDocList,
  getFlyCheckList,
  getSceneCheckList
} from "../../actions/publish";
import { getMonitorList } from "../../actions/monitor";

import Modal from "@mui/material/Modal";
import store from "../../store";

const styles = () => {
  return {
    homePage: {
      position: "relative",
      width: "100%",
      minHeight: "calc(100vh - 54px)",
      padding: "100px 20px 40px 20px",
      // background: `url(${bgIcon}) center top / 100vw 31.25vw no-repeat`,
      backgroundColor: "rgba(241, 242, 242)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column"
    },
    bgBox: {
      position: "absolute",
      left: "0",
      top: "0",
      width: "100%",
      height: "400px",
      background: `url(${bgIcon}) left top / 100vw 31.25vw no-repeat`,
      zIndex: 1
    },
    shadowBox: {
      position: "absolute",
      left: "-100px",
      top: "200px",
      width: "100%",
      background: "rgba(241, 242, 242)",
      height: "400px",
      filter: "blur(50px)",
      zIndex: 2
    },
    searchBox: {
      position: "relative",
      zIndex: "10",
      width: "100%",
      maxWidth: "72vw",
      height: "auto"
    },
    appName: {
      position: "absolute",
      right: "40px",
      top: "-80px",
      fontFamily: "newRoman",
      fontSize: "120px",
      lineHeight: "80px",
      display: "inline-block",
      color: "rgba(222,222,222,.91)",
      zIndex: 1
    },
    filterBox: {
      position: "relative",
      zIndex: 2,
      width: "100%",
      height: "80px",
      padding: "20px",
      borderRadius: "10px",
      boxShadow: "0 0px 10px rgba(0,0,0,.1)",
      background: "#fff",
      display: "flex",
      alignItems: "center",
      "& button": {
        background: "#0F55A4",
        border: "none",
        "&:hover": {
          background: "#3f88c7"
        }
      }
    },
    inputBox: {
      flex: 1
    },
    fastSearchBox: {
      width: "100%",
      minHeight: "100px",
      padding: "20px 20px 0 20px",
      marginTop: "20px",
      borderRadius: "10px",
      boxShadow: "0 0px 10px rgba(0,0,0,.1)",
      background: "#fff"
    },
    fileResultBox: {
      width: "100%",
      minHeight: "100px",
      marginTop: "20px",
      borderRadius: "10px",
      boxShadow: "0 0px 10px rgba(0,0,0,.1)",
      background: "linear-gradient(180deg, rgb(229, 244, 251), #f7f7f7)"
    },
    dataResultBox: {
      width: "100%",
      minHeight: "100px",
      marginTop: "20px",
      borderRadius: "10px",
      boxShadow: "0 0px 10px rgba(0,0,0,.1)",
      background: "linear-gradient(180deg, rgb(222, 235, 252), #f7f7f7)"
    },
    searchInput: {
      flex: "1",
      height: "40px"
    },
    modalTitle: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "16px",
      fontWeight: "600",
      color: "#333",
      "& button": {
        background: "#0F55A4",
        border: "none",
        "&:hover, &:focus": {
          background: "#3f88c7"
        }
      }
    },
    resultTitle: {
      width: "100%",
      height: "40px",
      padding: "0 20px",
      lineHeight: "40px",
      fontSize: "16px",
      fontWeight: "600",
      color: "#333",
      borderBottom: "1px solid #fff"
    },
    tagBox: {
      width: "100%",
      marginTop: "14px",
      display: "flex",
      flexWrap: "wrap"
    },
    tag: {
      height: "36px",
      padding: "0 10px",
      borderRadius: "5px",
      marginRight: "20px",
      marginBottom: "20px",
      border: "1px solid #ddd",
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      "& .action": {
        marginLeft: "15px",
        color: "#ddd"
      },
      "&:hover": {
        border: "1px solid #0F55A4",
        color: "#0F55A4",
        "& .action": {
          color: "#0F55A4"
        }
      }
    },
    resultBox: {
      width: "100%",
      padding: "20px 20px 0 ",
      display: "flex",
      flexWrap: "wrap"
    },
    result: {
      width: "225px",
      height: "14px",
      marginBottom: "20px",
      fontSize: "14px",
      lineHeight: "14px",
      color: "#333",
      cursor: "pointer",
      "& .count": {
        fontWeight: "bold",
        paddingLeft: "10px",
        color: "#0F55A4"
      },
      "&:hover, &:focus": {
        color: "#0F55A4"
      },
      "& .name": {
        "&:hover": {
          textDecoration: "underline"
        }
      }
    },
    modalBox: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "500px",
      background: "#fff",
      boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.2)",
      borderRadius: "4px"
    },
    title: {
      width: "100%",
      height: "48px",
      padding: "0 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: "1px solid #e9e9e9",
      fontSize: "16px ",
      color: "#333",
      fontWeight: "600",
      boxSizing: "border-box",
      "& img": {
        cursor: "pointer"
      }
    },
    content: {
      position: "relative",
      width: "100%",
      padding: "40px 20px",
      boxSizing: "border-box"
    },
    optionBox: {
      position: "absolute",
      left: 0,
      top: "42px",
      width: "394px",
      maxHeight: "300px",
      overflow: "auto",
      boxShadow: "0 0 10px 3px rgba(0, 0, 0, .1)",
      backgroundColor: "#fff",
      padding: "5px 0"
    },
    bigOptionBox: {
      position: "absolute",
      left: "20px",
      top: "62px",
      width: "calc(100% - 100px)",
      maxHeight: "300px",
      overflow: "auto",
      boxShadow: "0 0 10px 3px rgba(0, 0, 0, .1)",
      backgroundColor: "#fff",
      padding: "5px 0"
    },
    optionLine: {
      width: "100%",
      height: "32px",
      fontSize: "15px",
      lineHeight: "32px",
      color: "#333",
      paddingLeft: "14px",
      cursor: "pointer",
      whiteSpace: "noWrap",
      overflow: "hidden",
      textOverflow: "",
      "&:hover": {
        backgroundColor: "#f6f6f6"
      }
    },
    inputGroup: {
      position: "relative",
      display: "flex",
      "& button": {
        background: "#0F55A4",
        border: "none",
        "&:hover, &:focus": {
          background: "#3f88c7"
        }
      }
    },
    footer: {
      position: "absolute",
      left: "0",
      bottom: "0",
      width: "100%",
      height: "30px",
      zIndex: "100",
      textAlign: "center",
      fontSize: "13px",
      color: "#999",
      lineHeight: "30px"
    },
    footerName: {
      marginLeft: "20px"
    },
    btn: {
      borderRadius: "0 !important"
    },
    redText: {
      color: "#f00"
    },
    nextBtn: {
      width: "calc(100% + 16px)",
      height: "24px",
      marginLeft: "-8px",
      marginTop: "-1px"
    },
    // 独立的Tab顶部条（放在搜索框上方，不包裹下面模块）
    tabTopBar: {
      width: "100%",
      background: "#fff",
      borderRadius: "16px",
      boxShadow: "0 0px 10px rgba(0,0,0,.1)",
      padding: "20px 32px",
      position: "relative",
      zIndex: 2,
      marginBottom: "20px"
    },
    // AI问答卡片（AI问答Tab下整卡包裹）
    tabWrapper: {
      width: "100%",
      background: "#fff",
      borderRadius: "16px",
      boxShadow: "0 0px 10px rgba(0,0,0,.1)",
      padding: "24px 32px 32px 32px",
      position: "relative",
      zIndex: 2
    },
    tabHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    tabButtons: {
      display: "flex",
      gap: "12px"
    },
    tabBtn: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "8px 20px",
      borderRadius: "20px",
      border: "none",
      background: "#fff",
      color: "#333",
      cursor: "pointer",
      fontSize: "14px",
      transition: "all .2s",
      boxShadow: "0 1px 4px rgba(0,0,0,.08)"
    },
    tabBtnActive: {
      background: "linear-gradient(135deg, #e4f0ff, #e0f2ff)",
      color: "#1565c0",
      fontWeight: 500,
      boxShadow: "0 2px 8px rgba(21,101,192,.2)"
    },
    historyBtn: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      padding: "6px 14px",
      borderRadius: "20px",
      background: "#fff",
      color: "#666",
      border: "1px solid #eee",
      cursor: "pointer",
      fontSize: "13px"
    },
    aiPrompt: {
      textAlign: "center",
      fontSize: "22px",
      fontWeight: 600,
      color: "#222",
      margin: "20px 0 24px 0",
      letterSpacing: "0.5px"
    },
    aiTextareaWrapper: {
      position: "relative",
      padding: "3px", // 渐变边框宽度 = 3px（保持渐变颜色不变）
      borderRadius: "10px",
      background: "linear-gradient(90deg, #4facfe, #a06cff, #fe4fa0)",
      marginBottom: "0"
    },
    aiTextarea: {
      display: "block", // 关键：清除 inline-block 基线预留的底部 4-6px 空白
      width: "100%",
      minHeight: "100px",
      border: "none",
      outline: "none",
      borderRadius: "8px",
      padding: "14px 16px",
      fontSize: "14px",
      resize: "none",
      background: "#fff",
      color: "#333",
      lineHeight: 1.6,
      boxSizing: "border-box"
    },
    aiSendBtn: {
      position: "absolute",
      right: "10px",
      bottom: "10px",
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      border: "none",
      background: "linear-gradient(135deg, #4facfe, #1976d2)",
      color: "#fff",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "16px",
      boxShadow: "0 2px 8px rgba(25,118,210,.4)",
      transition: "all .2s",
      "&:hover": {
        transform: "scale(1.05)",
        boxShadow: "0 4px 12px rgba(25,118,210,.5)"
      },
      "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed"
      }
    },
    aiBottomBtns: {
      display: "flex",
      gap: "12px",
      justifyContent: "flex-start"
    },
    aiSearchBtn: {
      padding: "8px 24px",
      borderRadius: "20px",
      background: "#fff",
      color: "#333",
      border: "1px solid #ddd",
      cursor: "pointer",
      fontSize: "14px",
      transition: "all .2s",
      "&:hover": {
        borderColor: "#1565c0",
        color: "#1565c0"
      }
    },
    aiSearchBtnActive: {
      border: "none",
      background: "#1976d2",
      color: "#fff",
      fontWeight: 500,
      boxShadow: "0 2px 8px rgba(25,118,210,.35)",
      "&:hover": {
        background: "#1565c0",
        color: "#fff"
      }
    },
    aiDeepBtn: {
      padding: "8px 24px",
      borderRadius: "20px",
      border: "none",
      background: "#1976d2",
      color: "#fff",
      fontWeight: 500,
      cursor: "pointer",
      fontSize: "14px",
      boxShadow: "0 2px 8px rgba(25,118,210,.35)",
      transition: "all .2s",
      "&:hover": {
        background: "#1565c0"
      }
    },
    tabBody: {
      width: "100%"
    },
    // 放在tabWrapper卡片内部的搜索行（与原filterBox布局一致，但无独立背景/阴影/圆角）
    filterBoxInner: {
      position: "relative",
      zIndex: 2,
      width: "100%",
      height: "80px",
      padding: "20px 0",
      display: "flex",
      alignItems: "center",
      "& button": {
        background: "#0F55A4",
        border: "none",
        "&:hover": {
          background: "#3f88c7"
        }
      }
    }
  };
};

let timer = null;

class Index extends Component {
  constructor(props) {
    super(props);
    this.ref1 = React.createRef(null);
    this.ref2 = React.createRef(null);
    this.ref3 = React.createRef(null);
  }

  state = {
    username: store.getState().auth.username,
    applicationId: localStorage.getItem("applicationId"),
    userId: "",
    keyword: "",
    keywordBak: "",
    newKeyword: "",
    keywordList: [],
    isModalOpen: false,
    fileResultBox: [],
    resultList: [],
    fastList: [],
    urlList: [],
    optionsList: [],
    showFile: false,
    fileLoading: false,
    showResult: false,
    resultLoading: false,
    openTour: false,
    tourKey: 0,
    tourCurrent: 0,
    isSearch: false,
    activeTab: "smart", // 'smart' 智能检索 | 'ai' AI问答
    aiQuestion: "",
    aiMode: "deep" // 'comprehensive' 综合检索 | 'deep' 深度思考
  };

  initQuickList = () => {
    getQuickList({
      is_quick_search: true,
      record_user__id: this.state.userId
    }).then((res) => {
      this.setState({
        fastList: res.results
      });
    });
  };

  //查询用户信息;
  queryUserInfo = () => {
    getUserInfo({ username: this.state.username }).then((res) => {
      if (res.results && res.results.length > 0) {
        let userData = res.results[0];
        if (userData) {
          this.setState(
            {
              userId: userData.id,
              openTour: userData.beginner_index == 0
            },
            () => {
              this.initQuickList();
            }
          );
        }
      }
    });
  };

  componentDidMount() {
    this.setState(
      {
        username: store.getState().auth.username
      },
      () => {
        this.queryUserInfo();
      }
    );
  }

  handleSearch = (newValue) => {
    searchOptions({
      keyword: newValue
    }).then((res) => {
      let list = res.result || [];
      this.setState({
        keywordList: list,
        tourKey: this.state.tourKey + 1
      });
    });
  };

  handleChange = (e) => {
    let val = e.target.value;
    this.setState({
      keyword: val
    });

    clearTimeout(timer);
    timer = setTimeout(() => {
      this.handleSearch(val);
    }, 300);
  };
  handleChangeKeyword = (e) => {
    let val = e.target.value;
    this.setState({
      newKeyword: val
    });

    clearTimeout(timer);
    timer = setTimeout(() => {
      this.getHistoryList(val);
    }, 300);
  };

  getHistoryList = (val) => {
    getQuickList({
      is_quick_search: true,
      record_content__icontains: val
    }).then((res) => {
      let list = res.results;
      let newList = [];
      list.forEach((v) => {
        let index = newList.findIndex((val) => {
          return v.record_content == val.record_content;
        });
        if (index == -1) {
          newList.push(v);
        }
      });
      this.setState({
        optionsList: newList.slice(0, 100)
      });
    });
  };

  searchKeyword = () => {
    if (!this.state.keyword) {
      return;
    }
    this.setState({
      keywordList: []
    });
    // 查询文件类结果
    this.setState({
      showFile: true,
      fileLoading: true,
      isSearch: true,
      tourKey: this.state.tourKey + 1
    });
    searchAll({
      application_id: this.state.applicationId,
      keyword: ""
      // keyword: this.state.keyword
    }).then((res) => {
      this.setState({
        fileLoading: false,
        keywordBak: this.state.keyword,
        tourKey: this.state.tourKey + 1,
        fileResultBox: (res.result || [])
          .map((v) => {
            let name = "";
            let count = "";
            for (let key in v) {
              if (key != "url" && key != "keyword") {
                name = key;
                count = v[key];
              }
            }
            return {
              name,
              count,
              url: v.url,
              keyword: v.keyword
            };
          })
          .sort((a, b) => {
            return a.name == "法律法规" ? -1 : 1;
          })
      });
    });

    let param = {
      PageNo: 1,
      PageSize: 1,
      KeyWord: this.state.keyword
    };
    let resultList = [];
    // 数据类查询，根据用户拥有的url，逐个调用接口
    let urls = localStorage.getItem("userUrls");
    let userUrlList = [];
    if (urls) {
      userUrlList = urls.split(",");
    }
    let nameList = [];
    let urlList = [];
    let fnList = [];
    userUrlList.forEach((v) => {
      switch (v) {
        case "/publish":
          nameList.push("批件发布数据");
          urlList.push(v);
          fnList.push(getPublishList(param));
          break;
        case "/inheritance":
          nameList.push("人类遗传数据");
          urlList.push(v);
          fnList.push(getHumanList(param));
          break;
        case "/innovate":
          nameList.push("创新与优先");
          urlList.push(v);
          fnList.push(getInnovateList(param));
          break;
        case "/reviewSummary":
          nameList.push("审评答疑汇总");
          urlList.push(v);
          fnList.push(getReviewSummaryList(param));
          break;
        case "/cma":
          nameList.push("Cma数据筛查");
          urlList.push(v);
          fnList.push(getCmaList(param));
          break;
        case "/classify":
          nameList.push("分类界定");
          urlList.push(v);
          fnList.push(getClassifyData(param));
          break;
        case "/train":
          nameList.push("培训信息汇总");
          urlList.push(v);
          fnList.push(getTrainList(param));
          break;
        case "/reviewExport":
          nameList.push("评审专家");
          urlList.push(v);
          fnList.push(getReviewExportList(param));
          break;
        case "/accessProblem":
          nameList.push("受理前咨询");
          urlList.push(v);
          fnList.push(getAccessProblemList(param));
          break;
        case "/practicalLink":
          nameList.push("实用链接");
          urlList.push(v);
          fnList.push(getPracticalLinkList(param));
          break;
        case "/punishDoc":
          nameList.push("行政处罚文书");
          urlList.push(v);
          fnList.push(getPunishDocList(param));
          break;
        case "/flyCheck":
          nameList.push("医疗器械飞行检查情况");
          urlList.push(v);
          fnList.push(getFlyCheckList(param));
          break;
        case "/sceneCheck":
          nameList.push("医疗器械生产现场检查");
          urlList.push(v);
          fnList.push(getSceneCheckList(param));
          break;
        case "/monitor":
          nameList.push("警戒监测");
          urlList.push(v);
          fnList.push(getMonitorList(param));
          break;
        case "/standardSubstance":
          nameList.push("标准物质");
          urlList.push(v);
          fnList.push(getStandardSubstanceList(param));
          break;
        case "/medicalEquipment":
          nameList.push("分类目录");
          urlList.push(v);
          fnList.push(getMedicalEquipmentList(param));
          break;
        default:
          break;
      }
    });
    if (fnList.length > 0) {
      this.setState({
        showResult: true,
        resultLoading: true
      });
    }
    Promise.all(fnList).then((res) => {
      let list = res.map((v, i) => {
        return {
          label: nameList[i],
          count: v.DataNumber,
          url: urlList[i],
          keyword: this.state.keyword
        };
      });
      this.setState({
        resultList: list,
        resultLoading: false,
        tourKey: this.state.tourKey + 1
      });
    });
  };

  handleCancel = () => {
    this.setState({
      isModalOpen: false,
      optionsList: []
    });
  };

  handleOk = () => {
    this.setState({
      optionsList: []
    });
    addQuick({
      keyword: this.state.newKeyword
    }).then((res) => {
      if (res.result) {
        this.initQuickList();
        this.setState({
          isModalOpen: false,
          newKeyword: ""
        });
      }
    });
  };

  openModal = () => {
    this.setState({
      isModalOpen: true
    });
  };

  deleteQuick = (data) => {
    removeQuick(
      {
        is_quick_search: false
      },
      data.id
    ).then((res) => {
      if (res.id) {
        this.initQuickList();
      }
    });
  };

  toResult = (data) => {
    // this.props.history.push(`${data.url}?keyword=${data.keyword}`)
    let origin = window.location.origin;
    let url = `${origin}${data.url}?keyword=${this.state.keywordBak}&type=search`;
    window.open(url);
  };

  toSearch = (val) => {
    this.setState(
      {
        keyword: val
      },
      () => this.searchKeyword()
    );
  };

  chooseKeywordOption = (val) => {
    this.setState({
      keywordList: [],
      keyword: val
    });
  };
  chooseOption = (val) => {
    this.setState({
      optionsList: [],
      newKeyword: val
    });
  };

  hideOptions = () => {
    this.setState({
      keywordList: []
    });
  };

  stopEvent = (e) => {
    e.stopPropagation();
  };

  closeTour = () => {
    this.setState({
      openTour: false
    });
    // 更新新手指引状态
    editUserInfo({
      beginner_index: 1
    });
  };

  changeTour = (current) => {
    this.setState({
      tourCurrent: current
    });
  };

  // Tab切换
  handleTabChange = (tab) => {
    this.setState({
      activeTab: tab
    });
  };

  // AI问答输入
  handleAiChange = (e) => {
    this.setState({
      aiQuestion: e.target.value
    });
  };

  // AI问答回车发送，Shift+Enter换行
  handleAiKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      this.handleAiSubmit();
    }
  };

  // AI问答提交
  handleAiSubmit = () => {
    const baseUrl = "https://ai.anwin.co/boying";
    const question = (this.state.aiQuestion || "").trim();
    const targetUrl = question
      ? `${baseUrl}?question=${encodeURIComponent(question)}`
      : baseUrl;
    window.open(targetUrl, "_blank");
  };

  // 切换AI模式：综合检索/深度思考
  handleAiModeChange = (mode) => {
    this.setState({ aiMode: mode });
  };

  // 打开历史记录
  openHistory = () => {
    // TODO: 打开历史记录弹窗/抽屉，这里先占位
    console.log("打开历史记录");
  };

  render() {
    const classes = this.props.classes;

    const steps = [
      {
        title: "请在搜索框内输入需检索的关键词",
        description: <span className={classes.redText}>输入内容不可为空</span>,
        target: () => this.ref1.current,
        nextButtonProps: {
          children: (
            <Button
              className={classes.nextBtn}
              disabled={!this.state.keyword}
              type="primary"
              size="small"
            >
              下一步
            </Button>
          )
        }
      },
      {
        title: "",
        description: "点击搜索",
        target: () => this.ref2.current,
        nextButtonProps: {
          children: (
            <Button
              className={classes.nextBtn}
              disabled={!this.state.isSearch}
              type="primary"
              size="small"
            >
              下一步
            </Button>
          )
        }
      },
      {
        title: "",
        description: "点击搜索结果跳转对应模块，快来试试吧",
        target: () => this.ref3.current
      }
    ];

    return (
      <div className={classes.homePage} onClick={this.hideOptions}>
        <div className={classes.shadowBox}></div>
        <div className={classes.bgBox}></div>

        <div className={classes.searchBox}>
          <div className={classes.appName}>BOYIN</div>

          {/* ============ 智能检索：Tab+搜索框 同在 tabWrapper 一张卡片内；下面的快速检索/结果保持同级 ============ */}
          {this.state.activeTab === "smart" && (
            <>
              <div className={classes.tabWrapper} onClick={this.stopEvent}>
                <div className={classes.tabHeader}>
                  <div className={classes.tabButtons}>
                    <button
                      className={`${classes.tabBtn} ${classes.tabBtnActive}`}
                      onClick={() => this.handleTabChange("smart")}
                      type="button"
                    >
                      <SearchOutlined />
                      <span>智能检索</span>
                    </button>
                    <button
                      className={classes.tabBtn}
                      onClick={() => this.handleTabChange("ai")}
                      type="button"
                    >
                      <MessageFilled style={{ color: "#7aa2ff" }} />
                      <span>AI 问答</span>
                    </button>
                  </div>
                </div>

                {/* 与Tab同卡内的搜索框（原L1037-1068的filterBox内容） */}
                <div className={classes.filterBoxInner}>
                  <div ref={this.ref1} className={classes.inputBox}>
                    <Input
                      value={this.state.keyword}
                      size="large"
                      onChange={this.handleChange}
                      placeholder="搜索"
                    />
                    {this.state.keywordList.length > 0 && (
                      <div className={classes.bigOptionBox}>
                        {this.state.keywordList.map((v, i) => (
                          <div
                            key={i}
                            className={classes.optionLine}
                            onClick={() => this.chooseKeywordOption(v)}
                          >
                            {v}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <Button
                    type="primary"
                    size="large"
                    onClick={this.searchKeyword}
                    className={classes.btn}
                    ref={this.ref2}
                  >
                    搜索
                  </Button>
                </div>
              </div>

              {/* 快速检索（同级，不被包） */}
              <div className={classes.fastSearchBox}>
                <div className={classes.modalTitle}>
                  快速检索
                  <Button type="primary" size="small" onClick={this.openModal}>
                    <PlusOutlined />
                    添加关键词
                  </Button>
                </div>
                <div className={classes.tagBox}>
                  {this.state.fastList.map((v, i) => (
                    <div
                      className={classes.tag}
                      key={i}
                      onClick={() => this.toSearch(v.record_content)}
                    >
                      <span>{v.record_content}</span>
                      <span
                        className="action"
                        onClick={() => this.deleteQuick(v)}
                      >
                        <CloseCircleOutlined />
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* 结果区（同级，不被包） */}
              <div ref={this.ref3}>
                {this.state.showFile && (
                  <Spin spinning={this.state.fileLoading}>
                    <div className={classes.fileResultBox}>
                      <div className={classes.resultTitle}>文件搜索范围</div>
                      <div className={classes.resultBox}>
                        {this.state.fileResultBox.map((v, i) => (
                          <div
                            key={i}
                            className={classes.result}
                            onClick={() => this.toResult(v)}
                          >
                            <span className="name">{v.name}</span>
                            <span className="count">{v.count}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Spin>
                )}
                {this.state.showResult && (
                  <Spin spinning={this.state.resultLoading}>
                    <div className={classes.dataResultBox}>
                      <div className={classes.resultTitle}>数据检索结果</div>
                      <div className={classes.resultBox}>
                        {this.state.resultList.map((v, i) => (
                          <div
                            key={i}
                            className={classes.result}
                            onClick={() => this.toResult(v)}
                          >
                            <span className="name">{v.label}</span>
                            <span className="count">{v.count}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </Spin>
                )}
              </div>
            </>
          )}

          {/* ============ AI问答：整卡包裹（Tab+内容一张卡片，无历史记录） ============ */}
          {this.state.activeTab === "ai" && (
            <div className={classes.tabWrapper} onClick={this.stopEvent}>
              <div className={classes.tabHeader}>
                <div className={classes.tabButtons}>
                  <button
                    className={classes.tabBtn}
                    onClick={() => this.handleTabChange("smart")}
                    type="button"
                  >
                    <SearchOutlined />
                    <span>智能检索</span>
                  </button>
                  <button
                    className={`${classes.tabBtn} ${classes.tabBtnActive}`}
                    onClick={() => this.handleTabChange("ai")}
                    type="button"
                  >
                    <MessageFilled style={{ color: "#1565c0" }} />
                    <span>AI 问答</span>
                  </button>
                </div>
              </div>

              <div className={classes.aiPrompt}>今天想查询哪项法规？</div>
              <div className={classes.aiTextareaWrapper}>
                <textarea
                  className={classes.aiTextarea}
                  value={this.state.aiQuestion}
                  onChange={this.handleAiChange}
                  onKeyDown={this.handleAiKeyDown}
                  placeholder="Enter发送，Shift+Enter换行"
                />
                <button
                  type="button"
                  className={classes.aiSendBtn}
                  onClick={this.handleAiSubmit}
                  title="发送"
                >
                  <SendOutlined />
                </button>
              </div>
            </div>
          )}
        </div>

        <Modal
          open={this.state.isModalOpen}
          onCancel={this.handleCancel}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className={classes.modalBox}>
            <div className={classes.title}>
              <div>添加关键词</div>
              <div onClick={this.handleCancel}>
                <img src={closeSvg} />
              </div>
            </div>
            <div className={classes.content}>
              <div className={classes.inputGroup}>
                <Input
                  placeholder="请输入关键词"
                  value={this.state.newKeyword}
                  onFocus={() => this.getHistoryList(this.state.newKeyword)}
                  onChange={this.handleChangeKeyword}
                  size="large"
                ></Input>
                <Button
                  onClick={this.handleOk}
                  className={classes.btn}
                  type="primary"
                  size="large"
                >
                  添加
                </Button>
                {this.state.optionsList.length > 0 && (
                  <div className={classes.optionBox}>
                    {this.state.optionsList.map((v, i) => (
                      <div
                        key={i}
                        className={classes.optionLine}
                        onClick={() => this.chooseOption(v.record_content)}
                      >
                        {v.record_content}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal>

        <div className={classes.footer}>
          京ICP备2021001914号
          <span className={classes.footerName}>
            北京安楹康思医学科技有限公司
          </span>
        </div>
        <Tour
          key={this.state.tourKey}
          current={this.state.tourCurrent}
          onChange={this.changeTour}
          open={this.state.openTour}
          placement="top"
          closeIcon={false}
          indicatorsRender={() => <></>}
          onFinish={this.closeTour}
          steps={steps}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, {})
)(withRouter(Index));
